// extracted by mini-css-extract-plugin
export var closeButton = "_lp-1";
export var closeX = "_lp-3";
export var container = "_lp-0";
export var image = "_lp-2";